<template>
    <v-btn color="accent primary--text text--darken-3" @click="hardRefresh">
      {{ buttonText }}
    </v-btn>
  </template>
  
  <script>
  export default {

    props: {
        buttonText: String
    },

    methods: {
      hardRefresh() {
        window.location.reload(true)
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/shared/hardRefresh.vue